web = window.web = window.web || {};
web.credits = window.web.credits = window.web.credits || {};
web.creditsSection = window.web.creditsSection = window.web.creditsSection || {};

var $ = require('jquery');
web.creditsSectionSection = require('./Section');

web.creditsSectionManager = module.exports = function(options) {
    var t = this;
    t.instanceState = 'constructed';

    t.defaults = {};

    t.options = $.extend({}, t.defaults, options);

    t.CSS_SELECTOR_PREFIX = null;

    t.$context = null;

    t.sectionsInstances = [];

    t.activeSectionInstance = null;

};

web.creditsSectionManager.prototype = {
    init: function(){
        var t = this;

        t.setContext($(t.CSS_SELECTOR_PREFIX+"sections"));
        t._createSectionsInstances();
        t._bindEvents();
    },

    setContext: function($context) {
        var t = this;

        t.$context = $context;
    },

    setSelectorPrefix: function(selectorPrefix){
        var t = this;

        t.CSS_SELECTOR_PREFIX = selectorPrefix;
    },

    _bindEvents: function(){
        var t = this;

        $(t.sectionsInstances).each(function(i, sectionInstance) {
            $(sectionInstance).on("click", function(e){
                t.unsetAllActiveSections();
                t._setActiveSection(e.sectionInstance);
            });

            $(sectionInstance).on("iAmActiveNow", function(e) {
                $(t).trigger({
                    type: "activeSectionInstanceSet",
                    activeSectionInstance: e.iAm,
                    activeSectionId: e.myId,
                    activeSectionUrl: e.myUrl
                });
            });

            $(sectionInstance).on("iAmNotActiveNow", function(e) {
                $(t).trigger({
                    type: "unactiveSectionInstanceSet",
                    unactiveSectionInstance: e.iAm,
                    unactiveSectionId: e.myId,
                    unactiveSectionUrl: e.myUrl
                });
            })

        });

    },

    unsetAllActiveSections: function(){
        var t = this;

        $(t.sectionsInstances).each(function(i, sectionInstance) {
            sectionInstance.setActive(false);
            sectionInstance.redraw();
        });
    },

    _setActiveSection: function(sectionInstance){
        var t = this;
        sectionInstance.setActive(true);
        sectionInstance.redraw();
        t._setActiveSectionInstance(sectionInstance);
    },

    _createSectionsInstances: function(){
        var t = this;

        t._get$sections().each(function(){
            var $this = $(this);

            var sectionInstance = new web.creditsSectionSection($this);
            sectionInstance.init();
            t.sectionsInstances.push(sectionInstance);
        });

    },

    _get$sections: function() {
        var t = this;

        return t.$context.find(t.CSS_SELECTOR_PREFIX+"section");
    },

    _setActiveSectionInstance: function(activeSectionInstance){
        var t = this;

        t.activeSectionInstance = activeSectionInstance;
    },

    getActiveSectionInstance: function(){
        var t = this;
        return t.activeSectionInstance;
    },

    setActiveSectionById: function(sectionId){
        var t = this;

        var sectionInstance = t.getSectionById(sectionId);
        t._setActiveSection(sectionInstance);

    },

    getSectionById: function(sectionId){
        var t = this;
        var ret = null;

        $(t.sectionsInstances).each(function(i, sectionInstance) {
            if (sectionInstance.getId() == sectionId) {
                ret = sectionInstance;
            }
        });

        return ret;

    }
};


// WEBPACK FOOTER //
// ./fe/web-default/src/js/credits/section/Manager.js